export default __webpack_public_path__ + "static/media/22_ChangYong.6924b7d6.png";